<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">
            {{'Warning' | translate | async}}
        </span>
        <i class="material-icons ttmodal__close-button" (click)="cancel()" matTooltip="Close">close</i>
    </div>
    <div class="ttmodal__body">
        <div class="margin">
            <p>
                This system has historical equipment associations and inspection records.
                Adding a new component may impact historical data and could take longer to complete. 
                Please verify the equipment listed below before continuing.
            </p>
        </div>
        <div class="div-size" *ngIf="equipmentHistory?.length >  0">
            <mat-divider></mat-divider>
            <div class="padding">{{'Equipments will be affected by this action' }}</div>
            <table mat-table [dataSource]="equipmentHistory" class="table-border">
                <ng-container matColumnDef="InspDate">
                    <th mat-header-cell *matHeaderCellDef>{{'Inspection Date' | translate | async}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.InspectionDate | date:'yyyy-MM-dd' }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="SystemSerial">
                    <th mat-header-cell *matHeaderCellDef>{{'System Serial No' | translate | async}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.SystemSerialNo }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="SerialNo">
                    <th mat-header-cell *matHeaderCellDef>{{'Equipment Serial No' | translate | async}}</th>
                    <td mat-cell *matCellDef="let element">
                        <span class="text-block__important">
                            <a 
                                (click)="openEquipment(element.PrevSystemEquipmentId)"
                                [matTooltip]="'Manage Equipment' | translate | async">
                                {{element.EquipmentSerialNo}}
                            </a>
                        </span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="UnitNo">
                    <th mat-header-cell *matHeaderCellDef>{{'Equipment Unit No' | translate | async}}</th>
                    <td mat-cell *matCellDef="let element">
                        <span class="text-block__important">
                            <a 
                                (click)="openEquipment(element.PrevSystemEquipmentId)" 
                                [matTooltip]="'Manage Equipment' | translate | async">
                                {{element.EquipmentUnitNo}}
                            </a>
                        </span>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
    </div>
    <div class="ttmodal__footer">
        <button mat-raised-button (click)="cancel()"> {{ 'Cancel' | translate | async }}</button>
        <button mat-raised-button color="warn" (click)="goAhead()">
            <span class="material-icons button__icon">check</span><span class="button__text">
                {{ 'OK' | translate | async }}
            </span>
        </button>
    </div>
</div>